export enum FilterGroupType {
  Checkbox = 'Checkbox',
  Range = 'Range',
  ColorCheckbox = 'ColorCheckbox',
}
